const SELECTOR = '[data-modal-confirm]:not([data-confirm-callback])';

export default async function mountConfirm(props) {
  const { default: Confirm } = await import('@bizneo/confirm/confirm.svelte');

  const confirm = new Confirm({
    target: document.body,
    props,
  });

  $(confirm.getContainer()).trigger('dom-update', { source: 'confirm' });

  return confirm;
}

$(document).on('click', `${SELECTOR}`, async (e) => {
  const $el = $(e.target).data().confirm === undefined ? $(e.target).closest('[data-modal-confirm]') : $(e.target);
  const data = $el.data();
  data.confirm = data.modalConfirm;

  const confirm = await mountConfirm(data);

  confirm.$on('close', () => confirm.$destroy());
  confirm.$on('confirm', () => {
    if (data.removeNestedFields) {
      $(`#${data.removeNestedFields}`).find('.remove_nested_fields')[0].click();
      confirm.$destroy();
    } else {
      const $link = $(`<a href=${data.to}></a>`).hide();
      if (data.notRemote === undefined) $link.attr('data-remote', 'true').attr('data-method', 'delete');
      if (data.notRemote === undefined && data.actionMethod === undefined) $link.attr('data-method', 'delete');
      if (data.actionMethod) $link.attr('data-method', data.actionMethod);
      $el.after($link);
      $link[0].click();
      confirm.$destroy();
    }
  });
});
